import { render, staticRenderFns } from "./ImageElement.vue?vue&type=template&id=fa9899aa&scoped=true&"
import script from "./ImageElement.vue?vue&type=script&lang=js&"
export * from "./ImageElement.vue?vue&type=script&lang=js&"
import style0 from "./ImageElement.vue?vue&type=style&index=0&id=fa9899aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9899aa",
  null
  
)

export default component.exports